module.exports = __webpack_public_path__ + "static/media/4t_website_logo_sup_tcuhk.7b58e614.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4t_website_logo_sup_tcuhk.jpg
// module id = 73
// module chunks = 0